const jwtRegex = new RegExp('mystellarqjwt=([^;]*);?');

// Stolen from Neuro for IE compatibility
const atobUtf8 = str => {
  // Going backwards: from bytestream, to percent-encoding, to original string.
  return decodeURIComponent(
    atob(str)
      .split('')
      .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join(''),
  );
};

/**
 * Gets raw JWT token string from cookie
 * @returns {string | undefined} Raw JWT token from cookie.
 */
export const getRawJWT = () => {
  const matchedCookies = document.cookie.match(jwtRegex);
  if (!matchedCookies || matchedCookies.length < 2) return undefined;

  return matchedCookies[1];
};

/**
 * Gets current JWT token data from cookies as JSON
 * @returns {object | undefined} Parsed JWT or undefined
 */
const getCurrentJWT = () => {
  const rawToken = getRawJWT();
  if (!rawToken) return undefined;

  try {
    return JSON.parse(atobUtf8(rawToken.split('.')[1]));
  } catch (error) {
    return undefined;
  }
};
/**
 * Checks if the JWT has expired
 * @param {object} jwt JSON web token to check
 * @returns {boolean} True/False depending on whether the JWT has expired
 */
export const isJWTExpired = jwt => {
  return jwt && jwt.exp && jwt.exp <= Date.now();
};

export const isJWTValid = () => {
  const jwt = getCurrentJWT();
  if (!jwt) return false;
  return !isJWTExpired(jwt);
};

export default getCurrentJWT;
